<script setup lang="ts">
import { sizes, type ISizes } from './styles';

interface Props {
  size?: ISizes | null | undefined;
  block?: boolean | undefined;
  rounded?: boolean | undefined;
  [x: string]: any;
};

const props = withDefaults(defineProps<Props>(), {
  rounded: true
});

const emit = defineEmits(['click', 'focus']);
</script>

<template>
  <div
    :class="[
      (block ? 'w-full' : 'w-fit'),
      ((size !== undefined) ? sizes[size] : 'padding-auto'),
      (rounded && 'rounded-auto'),
      ('text-auto'),
    ]"
    @click="(e: Event) => ((! disabled) ? emit('click', e) : null)"
    @focus="(e: Event) => ((! disabled) ? emit('focus', e) : null)">
    <slot />
  </div>
</template>
